import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodPhysicalInventoryWarehouse  {
    _originalTypeClassName = "zERP.BO.GoodPhysicalInventoryWarehouse";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodPhysicalInventoryWarehouse.translate = translateService;
}
this.GoodContents = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Warehouse:any;
GoodContents:any;
static setWarehouse = ($this, value) => {
var oldValue = $this.Warehouse;
$this.Warehouse = value;
if (value != null) {
}
}
static setGoodContents = ($this, items) => {
                if (items == null) items = [];
                if ($this.GoodContents == null) $this.GoodContents = [];

                const copyItems = Common.cloneObject(items);

                while ($this.GoodContents.length > 0) {
                    Domain.GoodPhysicalInventoryWarehouse.removeGoodContents($this, $this.GoodContents[0]);
                }

                Domain.GoodPhysicalInventoryWarehouse.addManyGoodContents($this, copyItems);
            }
static addManyGoodContents = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodPhysicalInventoryWarehouse.addGoodContents($this, items[i]);
                }
            }
static addGoodContents = ($this, item) => {
                if ($this.GoodContents == null) $this.GoodContents = [];
                if (item == null || $this.GoodContents.indexOf(item) > -1) return;
                $this.GoodContents.push(item);
}
static addRangeGoodContents = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodPhysicalInventoryWarehouse.addGoodContents($this, item));
            }
static removeGoodContents = ($this, item) => {
                if ($this == null || $this.GoodContents == null || $this.GoodContents.indexOf(item) === -1) return;
                var _index = $this.GoodContents.indexOf(item);
                $this.GoodContents.splice(_index, 1);
}
static clearGoodContents = ($this) => { $this.GoodContents = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}